import ScreenCreditBundleList from 'screens/CreditBundle/List';
import ScreenCreditBundleCreate from 'screens/CreditBundle/Create';
import ScreenCreditBundleReport from 'screens/CreditBundle/Report';
import { CREDIT_BUNDLE } from 'routes/paths';

const creditBundleRoutes = [
  {
    path: CREDIT_BUNDLE.LIST,
    name: 'CreditBundleList',
    component: ScreenCreditBundleList,
    allowPermissions: ['list_creditbundle', 'list_ownership_creditbundle'],
  },
  {
    path: CREDIT_BUNDLE.CREATE,
    name: 'CreditBundleCreate',
    component: ScreenCreditBundleCreate,
    allowPermissions: ['add_creditbundle', 'add_ownership_creditbundle'],
  },
  {
    path: CREDIT_BUNDLE.REPORT,
    name: 'CreditBundleReport',
    component: ScreenCreditBundleReport,
    // Use old report permissions
    allowPermissions: ['report_autopaidad', 'report_ownership_autopaidad'],
  },
];

export default creditBundleRoutes;
